import * as _tangramParser from '@tangram/parser';
import { getLingoParserAsync } from '@ad/lingo-parser/build/types/src/async';
import { globalShareModules, loadScriptPromise } from './utils';

export type TangramParserType = typeof _tangramParser;
export let tangramParser: TangramParserType = window['TangramParser'];

async function getLingoParserInstance() {
  const lingoParserInstance = await getLingoParserAsync();
  return lingoParserInstance;
}

export function getLingoParser() {
  return window['LingoParser'];
}

export let lcdpMapping: { [key: string]: string } = window[Symbol.for('LCDP_MAPPING')] || {};

export async function initComponents(parserType?: 'lingo' | 'tangram') {
  const cdn_public_path = window['cdn_public_path'];
  try {
    await Promise.all(
      [
        loadScriptPromise(
          `${cdn_public_path || 'https://p2.adkwai.com'}/kos/nlav12060/lingo-polyfills/dist.js`,
          'lingo_polyfill_load'
        ),
        loadScriptPromise(
          `${cdn_public_path || 'https://static.yximgs.com'}/udata/pkg/tangram_platform/s.js`,
          'lingo_systemJs_load'
        ),
        // 默认就是lingo编译器
        !window['LingoParser'] && parserType !== 'tangram'
          ? getLingoParserInstance().then(instance => globalShareModules({ LingoParser: instance }))
          : null,
      ].filter(Boolean)
    );
  } catch (error) {
    console.error(
      error,
      '============= lingo_polyfill_load or lingo_systemJs_load fail ==========='
    );
  }
}

export async function init() {
  if (!tangramParser) {
    tangramParser = window['TangramParser'];
  }

  if (!Object.keys(lcdpMapping).length) {
    lcdpMapping = window[Symbol.for('LCDP_MAPPING')] || {};
  }
}
